import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";

import { errorNormalizer } from "../../../shared/Helpers/functions";
import { CustomSelect, CustomTable } from "../../../shared/uiComponents";
import { ReportFilters } from "../../Reports/helpers";
import { Container, FilterWrapper } from "./helpers";
import SoapNotesHeader from "../soapNotesHeader";
import { Headers, TableBody } from "./tableInfo";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getSoapNotesAdmin } from "../../../redux/State/clientSlice/soapNoteSlice";
import { SelectChangeEvent } from "@mui/material";

const sessionTypes = [
  { id: "1", name: "97151 - Assessment" },
  { id: "2", name: "97151 or H0032 - Treatment Planning" },
  { id: "3", name: "97153 - Behavior Treatment" },
  { id: "4", name: "97155 - Direct Supervision" },
  { id: "5", name: "97155 - Behavior Treatment Modification" },
  { id: "6", name: "97156 - Parent Training" },
  { id: "7", name: "Meet & Greet - 97153" },
  { id: "8", name: "Meet & Greet - Non-Billable" },
  { id: "", name: "All" },
];

const AdminSOAPNotes = () => {
  const [params, setParams] = useSearchParams();
  const sessionType = params.get("sessionType") ?? "";
  const dispatch = useDispatch<DispatchProperties>();

  const soapNotes = useSelector((state) => state.soapNote.soapNotes);
  const { clientId, endDate, startDate, userId } = useSelector(
    (state) => state.billing.billingFilters
  );
  const loading = useSelector((state) => state.soapNote.loading);

  useEffect(() => {
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";
    const direction = params.get("direction") || "";
    const orderBy = params.get("orderBy") || "";
    const searchString = params.get("search") || "";
    const status = params.get("status") || "";

    if (!startDate || !endDate) return;
    dispatch(
      getSoapNotesAdmin({
        page,
        pageSize,
        direction,
        orderBy,
        searchString,
        status,
        startDate,
        endDate,
        clientId,
        userId,
        sessionType,
      })
    )
      .then(unwrapResult)
      .catch(errorNormalizer);
  }, [params, clientId, endDate, startDate, userId, sessionType, dispatch]);

  const sessionTypeHandler = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    params.set("sessionType", value);
    setParams(params);
  };

  return (
    <Container>
      <SoapNotesHeader />
      <FilterWrapper>
        <ReportFilters showUsers={true} showShorcuts={false} />
        <div style={{ width: "250px" }}>
          <CustomSelect
            data={sessionTypes}
            value={sessionType}
            setValue={sessionTypeHandler}
            label="Session Type"
          />
        </div>
      </FilterWrapper>
      <CustomTable headers={Headers} data={soapNotes} TableBody={TableBody} loading={loading} />
    </Container>
  );
};

export default AdminSOAPNotes;
